import jszip from 'jszip';
window.JSZip = jszip;
import DataTable from 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-fixedheader';
import 'datatables.net-keytable';
import 'datatables.net-responsive';
import 'datatables.net-searchbuilder';
import 'datatables.net-staterestore';
import select2 from 'select2';

import './scripts/reports/group-quiz-report-module.js';
import './scripts/reports/lesson-topic-reports-module.js';
import './scripts/reports/quiz-module-reports.js';
import './scripts/reports/uo-question-report.js';
